// Filters meant for the global event list; on a single asset they are not needed.
const GLOBAL_ONLY_FILTER_FIELDS = ["regionId", "owningClientId", "userId"];

/** Drops the global-only filter TDAs (region, owning client, user) for event lists scoped to one asset. */
export const withoutGlobalOnlyFilters = <A extends { index: string }>(attributes: A[]): A[] =>
    attributes.filter((attribute) => !GLOBAL_ONLY_FILTER_FIELDS.includes(attribute.index));
